import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=488e95fa&scoped=true&"
import script from "./barcode.vue?vue&type=script&lang=js&"
export * from "./barcode.vue?vue&type=script&lang=js&"
import style0 from "./barcode.vue?vue&type=style&index=0&id=488e95fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e95fa",
  null
  
)

export default component.exports